import { GetBkgLogo } from '../Functions/GetBkgLogo';

export const BlockLegend = (props) => {
    const { parks } = props;
    let bkg;
    if (parks.length > 0) {
        return (
            <div className="legend-color">
                {parks.map((item, i) => {
                    bkg = GetBkgLogo(item.proute);
                    return (
                        <div className={`legend legend-${item.pslug}`} key={i}>
                            <div className={`color ${bkg}`}></div>
                            <div className="name">{item.pname}</div>
                        </div>
                    )
                })}
            </div>
        )
    } else {
        return (<></>)
    }
}